<div class="container">
  <ng-container *ngIf="data$ | async as data; else loading">
      <div class="title-wrap">
        <h1 class="title" (click)="backToAppsList()">
          <svg role="img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z">
            </path>
          </svg>
          {{ data.app.name }}
          <div class="version">{{ data.app.configSchemeVersion }}</div>
        </h1>
        <div class="actions">
          <button class="btn btn__primary btn__icon"
                  *ngIf="isEdited" routerLink="/chains/{{chainId}}/apps/app/{{appId}}/add"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              <path d="M0.999878 8H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"
                    stroke-linejoin="round"/>
            </svg>
            <span class="add">{{ 'pages.apps.actions.add' | translate }}</span>
          </button>
          <button class="btn btn__icon" [ngClass]="{'btn__secondary': !isEdited, 'btn__active': isEdited}" (click)="toggleEdit()">
            <span *ngIf="!isEdited">{{ 'pages.apps.actions.manage' | translate }}</span>
            <span *ngIf="isEdited">{{ 'pages.apps.actions.done' | translate }}</span>
          </button>
        </div>
      </div>
      <div class="app-list" *ngIf="data.configuredApps && data.configuredApps.length > 0; else empty">
        <app-app-view *ngFor="let app of data.configuredApps"
                      class="app-item"
                      [config]="app"
                      [restaurants]="(allRestaurants$ | async) ?? []"
                      [routerLink]="['configured', app.id]"
        >
        </app-app-view>
      </div>

      <ng-template #empty>
        <div class="empty">
          <span>{{ 'pages.apps.emptyConfigured'| translate }}</span>
        </div>
      </ng-template>
  </ng-container>


  <ng-template #loading>
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>

</div>
